import RewardTriggerEnum from '../../../../../Spirit/Entities/Enums/RewardTriggerEnum';
import CropAndSaveImageRequest from '../../../../../Spirit/Common/FileManager/Models/CropAndSaveImageRequest';
import RewardTranslationsUpdateRequest from '../../../../../Spirit/Admin/Interfaces/Models/Reward/RewardTranslationsUpdateRequest';

export default class UpdateRewardRequest  {
	RewardId?: number = null;
	Trigger: RewardTriggerEnum = null;
	Count: number = 0;
	Icon: CropAndSaveImageRequest = null;
	Translations: Array<RewardTranslationsUpdateRequest> = null;
	constructor(obj?: Partial<UpdateRewardRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
